import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from '@nuxtjs/composition-api';
import { computed, onMounted, onUnmounted } from 'vue';
import { useSanityCta } from '~/composables/useSanityCta';
import { useStore } from '~/store/composable';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';
import PromoBoxExchange from './PromoBoxExchange.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromoBoxLandingPage',
  props: {
    doc: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  doc?: ISanityDocuments[SanityDocumentSchema.PROMO_BOX];
  loading: boolean;
};



const { commit } = useStore();
const redirectOnClose = computed(() => props?.doc?.landingPageRedirectOnClose);
const { href, isExternalLink, isLoading } = useSanityCta(redirectOnClose);

onMounted(() => {
  commit('toggleHeader', false);
  commit('toggleFooter', false);
});

onUnmounted(() => {
  commit('toggleHeader', true);
  commit('toggleFooter', true);
});

return { __sfc: true,props, commit, redirectOnClose, href, isExternalLink, isLoading, PromoBoxExchange }
}

})